import { InputSelect,  InputSelectEn } from '../../atoms';
import React from 'react'; 

export function Select (props) {

    return (
        <> 
        <select  
          value={props.value || 'none'} 
          onChange={props.onChange} 
          className={`form__input font20Norm form__input_select form__input_select_${props.name} ${props.error ? 'form__input_error' : ''}`}
          name={props.name}
          id={props.id}
          aria-label='Выберите '
        >
          <option value="none" disabled>{props.actions}</option>
            {props.lib.length > 0 &&
            props.lib.map((item, index) => (
              <InputSelect item={item} key={index} />
            )) }
               
        </select> 
  
    </>
  )
}


export function SelectEn (props) { 
  return (
    <select  
    value={props.value || 'none'} 
    onChange={props.onChange} 
    className={`form__input form__input_select ${props.error ?  'form__input_error' : ''}`}
    name={props.name}
    id={props.id}
    aria-label='Выберите способ обработки продуктов'
  >
    <option value="none" disabled>{props.actions}</option>
    {props.lib.length > 0 &&
      props.lib.map((item, index) => (
        <InputSelectEn item={item} key={index} />
      ))}
       {props.error && <span className="form__text_error font14Norm">{props.error}</span>}
  </select>  
)
}


export function SelectEdit (props) { 
  function handleChange(e) { 
    props.onChange(e.target.value)
  }

  return (
    <select  
    value={props.value || 'none'} 
    onChange={handleChange} 
    className={`form__input form__input_select form__input_select_${props.name}`}
    name={props.name}
    id={props.id}
    aria-label='Выберите способ обработки продуктов'
  >
    <option value="none" disabled>{props.actions}</option>
    {props.lib.length > 0 &&
      props.lib.map((item, index) => (
        <InputSelectEn item={item} key={index} />
      ))}
  
  </select>  
)
}